<template>
    <div id="reports">
        <div v-if="!show_month">
            <h2>Reports for {{ show_year }}</h2>
            <div class="my-2">
                <span v-for="year in invoice_years">
                <router-link class="btn btn-sm btn-outline-primary mr-2" :to="{ name: 'report_year', params: { report_year: year }}">{{ year }}</router-link>
                    </span>
            </div>
            <table class="table table-hover table-striped table-bordered table-sm">
                <thead class="thead-dark">
                <tr>
                    <th>Month</th>
                    <th></th>
                </tr>
                </thead>
                <tr v-for="month in report_periods">
                    <td class="align-middle">{{ [ month, "MM" ] | moment("MMMM") }}</td>
                    <td class="text-right align-middle"><a class="btn btn-sm" @click="showMonth(month)">View Reports</a></td>
                </tr>
            </table>
        </div>
        <div v-if="show_month && clients && report_periods.length > 0">
            <report-select v-bind:invoices="report_periods" v-bind:clients="clients" v-bind:month="show_month" v-bind:year="show_year"></report-select>
        </div>
    </div>
</template>

<script>
    Vue.use(require('vue-moment'));

    export default {
        name: "ReportList",
        props: {
        },
        data() {
            return {
                clients: null,
                invoice_dates: [],
                invoice_years: [],
                report_periods: [],
                show_month: null,
                show_year: moment().format('YYYY'),
            }
        },
        mounted: function() {
            axios.post('/admin/clientlist').then(response => {
                this.clients = response.data;
                this.build_report_list();
            });
            this.updateShow();
        },
        methods: {
            build_report_list: function () {
                this.clients.forEach((client) => {
                    let api_config = {
                        headers: {
                            'Authorization': 'Bearer ' + client.api_token,
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                    }
                    axios.post(client.api + '/reports/revenue',{
                        client_code:client.client_code
                    }, api_config).then(response => {
                        client.invoices = response.data.revenue;
                        client.invoices.forEach((invoice) => {
                            this.invoice_dates.push(invoice.date);
                            this.invoice_years.push(moment(invoice.date).format('YYYY'));
                        });
                        this.invoice_dates = [...new Set(this.invoice_dates)];
                        this.invoice_years = [...new Set(this.invoice_years)];
                    });
                })
            },
            showYear: function (year) {
                this.show_year = year;
                this.getMonths(year);
                if(this.$route.params && this.$route.params.report_year !== this.show_year) {
                    this.$router.push({
                        name: 'report_year',
                        params: {report_year: this.show_year}
                    })
                }
            },
            showMonth: function (month) {
                this.show_month = month;
                if(this.$route.params && this.$route.params.report_month !== this.show_month) {
                    this.$router.push({
                        name: 'report_year_month',
                        params: {report_year: this.show_year, report_month: this.show_month}
                    })
                }
            },
            getMonths: function () {
                this.report_periods = [];
                this.invoice_dates.forEach((invoice) => {
                    if (moment(invoice).format('YYYY') === this.show_year) {
                        this.report_periods.push(moment(invoice).format('MM'));
                    }
                });
                this.report_periods = [...new Set(this.report_periods)];
            },
            clearMonth: function() {
                this.show_month = null;
            },
            updateShow: function() {
                if (this.$route.params) {
                    if (this.$route.params.report_year) {
                        this.showYear(this.$route.params.report_year);
                    }
                    if (this.$route.params.report_month) {
                        this.showMonth(this.$route.params.report_month);
                    } else {
                        this.clearMonth();
                    }
                }
            }
        },
        watch: {
            invoice_dates: function () {
                this.getMonths();
            },
            '$route' (to, from){
                this.updateShow();
            },
        }
    }
</script>
